import { WithSearchPageUseQueryContextProvider } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/WithSearchPageUseQueryContextProvider";
import React, { ReactNode } from "react";

export const WithSearchPageData = ({ children }: { children: ReactNode }) => {
  return (
    <WithSearchPageUseQueryContextProvider>
      {children}
    </WithSearchPageUseQueryContextProvider>
  );
};
